import { AppFunctionComponent } from "../../../../types"
import { RenderNode } from "@contentful/rich-text-react-renderer"
import { BLOCKS } from "@contentful/rich-text-types"
import React, { ReactNode } from "react"
import styled from "styled-components"
import RichText from "../../../../resolvers/rich-text/rich-text.resolver"
import { RenderRichText } from "../../../../types"

interface DescriptionProps {
  text: RenderRichText
}

const DescriptionText = styled.p`
  margin-top: 25px;
  font-size: ${12 / 16}rem;
  text-transform: uppercase;
  text-align: center;
`

const Description: AppFunctionComponent<DescriptionProps> = ({ text }) => {
  const customRenderNode: RenderNode = {
    [BLOCKS.PARAGRAPH]: (_, children: ReactNode) => (
      <DescriptionText>{children}</DescriptionText>
    ),
  }
  return <>{text && <RichText content={text} options={customRenderNode} />}</>
}

export default Description
